import { IconPack } from "../models/icons";

export const DEFAULT_ICON_PACK: IconPack = "source-mid-render-light-icons";

export const ICON_PACKS: IconPack[] = [
  "source-mid-render-light-icons",
  "source-mid-render-dark-icons",
  "source-state-icons",
  "source-system-icons",
  "source-tobi-icons",
  "source-hifi-light-icons",
  "custom-icons",
];

export const ICON_PACK_ICONS: { [iconPack: string]: string[] } = {
  "source-tobi-icons": [
    "angry",
    "big-smile",
    "birthday",
    "blush",
    "bubbly",
    "christmas",
    "confused",
    "default",
    "face-with-stuck-out-tongue",
    "hearts",
    "humble",
    "laugh",
    "laughing-tears",
    "love",
    "neutral",
    "sad",
    "shocked",
    "smirking",
    "sparkle",
    "st-patricks",
    "sweating",
    "whistle",
    "wink",
  ],
  "source-system-icons": [
    "2g",
    "3g",
    "4g-plus-plus",
    "4g-plus",
    "4g",
    "5g",
    "acceleration-low",
    "acceleration-middle",
    "acceleration",
    "accelerometer-middle",
    "accelerometer",
    "accessories",
    "ace",
    "activity",
    "add-friend",
    "add-ons",
    "admin",
    "alarm-assistant",
    "alarm",
    "all-rewards",
    "ambulance",
    "android",
    "anti-shock",
    "app-anytime",
    "app-channel-management",
    "app-channel-variety",
    "app-cloud-dvr",
    "app-discovery",
    "app-epg-backwards",
    "app-epg",
    "app-hd",
    "apps",
    "ar",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "attachment",
    "auto-top-up",
    "bag",
    "battery",
    "bike",
    "bill",
    "biometric-authentication",
    "block",
    "blog",
    "bold",
    "book",
    "bookmark",
    "boosting-pause",
    "boosting",
    "box",
    "bracelet-active",
    "bracelet-put-on",
    "braking",
    "briefcase",
    "bullet-list",
    "bundles",
    "business",
    "cable-error",
    "calendar-item",
    "calendar-month",
    "calendar",
    "call-log",
    "call",
    "camera-inactive",
    "camera",
    "car-key",
    "carer",
    "case-study",
    "celebrate",
    "charge-to-bill",
    "chart-bar",
    "chart-line",
    "chat",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "child-tracker",
    "chromecast",
    "clapping",
    "clock",
    "close",
    "cloud-download",
    "cloud-upload",
    "cluster-of-events",
    "colour-palette",
    "comment",
    "comments",
    "community",
    "compass",
    "complaints",
    "completed",
    "confidential",
    "connected-car",
    "connected-devices",
    "connected",
    "connectivity",
    "consultant",
    "contactless-payment",
    "contacts",
    "control-panel",
    "converged-proposition",
    "convert-currency",
    "copy",
    "cpu",
    "dark-mode",
    "dashboard",
    "data",
    "deals",
    "delete",
    "delivery",
    "device-diagnostics",
    "device-overview",
    "device-thickness",
    "diagnostics",
    "dial-pad",
    "disconnect",
    "dislike",
    "document-doc",
    "document-jpg",
    "document-pdf",
    "document-png",
    "document-ppt",
    "document-rtf",
    "document-svg",
    "document-xls",
    "document-zip",
    "document",
    "doorbell-camera",
    "double-stacked-pallet",
    "download",
    "drone",
    "dwdm",
    "e-sim",
    "edit",
    "end-call",
    "engineer",
    "enterprise",
    "entertainment",
    "environment",
    "error-circle",
    "error",
    "esim-logo",
    "essentials-broadband",
    "ethernet",
    "extender",
    "face-recognition",
    "failed",
    "fall-detection",
    "family",
    "favorite",
    "filter",
    "find-and-ring-my-device",
    "find-my-car",
    "firmware-update",
    "fitness-tracker",
    "focus",
    "folder",
    "forward",
    "game-console",
    "generic-device-iot",
    "genius",
    "giga-tv-a",
    "giga-tv-b",
    "gps-coverage",
    "gravity",
    "grid",
    "guest-wifi",
    "guru",
    "heart",
    "help-circle",
    "hide-password",
    "home-monitor",
    "home",
    "idea",
    "impact-alert",
    "incoming-call",
    "info-circle",
    "insert-code",
    "insurance",
    "intelligence-scan",
    "international",
    "iot",
    "iris-scanner",
    "italic",
    "kids-watch",
    "kippy-light",
    "landline-internet",
    "laptop",
    "lateral-movement",
    "layers",
    "like",
    "link-inster-edit",
    "list-view",
    "loan",
    "locate-me",
    "location-alert",
    "location-pin",
    "location",
    "log-in",
    "log-out",
    "mail-read",
    "mail",
    "make-payment",
    "map-gps",
    "map",
    "master",
    "maximize-image",
    "menu",
    "merge-call",
    "mesh-wifi-and-repeater",
    "microphone",
    "minimize-image",
    "minus-circle",
    "minus",
    "minutes-sms",
    "mobile",
    "mobiles",
    "monitor-brightness-contrast",
    "more-android",
    "more",
    "motion-alert",
    "motion-sensor",
    "motion",
    "move-money",
    "multimedia-port",
    "multiscreen",
    "mute",
    "my-trips",
    "network-patch-panel",
    "network-tower",
    "networker",
    "news",
    "nfc",
    "night-vision",
    "no-wifi",
    "notification-mute",
    "notification",
    "number-1",
    "number-2",
    "number-3",
    "number-4",
    "numbered-view",
    "offer-badge-percent",
    "offer-badge",
    "one-number",
    "online-form",
    "online",
    "outgoing-call",
    "padlock-close",
    "padlock-open",
    "parental-control",
    "parking-ticket",
    "password-key",
    "pause-circle",
    "pause",
    "payg",
    "payment-cvv",
    "payment",
    "pet-collar",
    "photos",
    "pie-chart",
    "pin",
    "ping",
    "placeholder",
    "play-arrow",
    "play-circle",
    "plus",
    "pop-in",
    "pop-out",
    "portals-for-videos",
    "power",
    "prepare",
    "price-promise",
    "price-tag",
    "print",
    "privacy",
    "pro",
    "profile",
    "public-sector",
    "public-wifi",
    "qr-code",
    "raffles",
    "rank-professor",
    "rank-savvy",
    "rank-scout",
    "rearrange",
    "refresh",
    "renewable-energy",
    "reply",
    "retake-photo",
    "return-product",
    "roaming",
    "robot",
    "router",
    "routines",
    "safe-zone",
    "save",
    "savings",
    "scan-credit-card",
    "screen-repair",
    "screen-size",
    "search-device",
    "search",
    "secure-grip",
    "security-camera",
    "send-tobi",
    "senior",
    "settings",
    "setup",
    "shake",
    "share-your-mins",
    "share",
    "shopping-checkout",
    "shopping-trolley",
    "show-password",
    "signed-in",
    "sim-swap",
    "sim",
    "single-pallet",
    "small-and-lightweight",
    "smart-camera",
    "smart-home",
    "smart-plug",
    "sme",
    "sms",
    "social-linkedin",
    "social-paypal",
    "social-pinterest",
    "soho",
    "sort",
    "sos-credit",
    "sos",
    "sound-active",
    "sound-off",
    "sound",
    "speeding",
    "spell-check",
    "steering-wheel",
    "stop-circle",
    "stop",
    "store-offer",
    "strike-through",
    "student",
    "super-wifi",
    "superstar",
    "switch-call",
    "switch-camera",
    "sync",
    "tablet-mobile",
    "tablet",
    "talk",
    "tethering",
    "theft",
    "tick-circle",
    "tick-outline",
    "tick",
    "to-do-list",
    "toggle",
    "top-up",
    "topics",
    "touch-screen",
    "trackisafe",
    "trainers",
    "translate",
    "trophy",
    "tv-epg",
    "tv-primetime",
    "tv-time-flexible",
    "tv-tv",
    "tv-uhd",
    "tv",
    "underlined",
    "unified-communications",
    "unlimited",
    "unlocked-rewards",
    "upgrade",
    "upload",
    "usb-modem",
    "user-log-in",
    "user-scan",
    "users",
    "v-car-dongle",
    "v-car",
    "v-pet",
    "video-frame",
    "video",
    "virtuoso",
    "virus-protection",
    "vodafone-store",
    "vodafone-tv",
    "voicemail",
    "vr-headset",
    "warning",
    "watch",
    "waterproof",
    "web-protection",
    "website",
    "weight",
    "wifi-good",
    "withdraw-cash",
    "wizard",
    "zoom-in",
    "zoom-out",
  ],
  "source-state-icons": [
    "error-inverse",
    "error",
    "info-inverse",
    "info",
    "success-inverse",
    "success",
    "warn-inverse",
    "warn",
  ],
  "source-mid-render-light-icons": [
    "1st-month-free",
    "3g",
    "4g",
    "4g-plus",
    "4g-plus-plus",
    "5g",
    "acceleration",
    "accelerometer",
    "accelerometer-low",
    "accelerometer-middle",
    "accessories",
    "add-document",
    "add-ons",
    "admin",
    "alarm",
    "alexa",
    "all-rewards",
    "ambulance",
    "anti-shock",
    "apps",
    "backspace",
    "bag",
    "barcode",
    "battery",
    "battery-low",
    "battery-really-low",
    "bill",
    "bill-pay-phone",
    "biometric-authentication",
    "birthday-greeting",
    "blog",
    "book",
    "box",
    "bracelet-active",
    "bracelet-disabled",
    "bracelet-generic",
    "bracelet-not-found",
    "bracelet-off",
    "bracelet-on",
    "bracelet-put-on",
    "bracelet-remove",
    "briefcase",
    "bundles",
    "business",
    "calculator",
    "calendar",
    "calendar-14",
    "calendar-month",
    "call",
    "camera",
    "cancel",
    "carer",
    "case-study",
    "celebrate",
    "charge-to-bill",
    "chart-bar",
    "chart-line",
    "chat",
    "clapping",
    "clock",
    "cloud-download",
    "cloud-upload",
    "comment",
    "comments",
    "community",
    "complaints",
    "completed",
    "connected-car",
    "connected-devices",
    "connectivity",
    "consultant",
    "contactless-payment",
    "contacts",
    "control-panel",
    "converged-proposition",
    "dashboard",
    "data",
    "deals",
    "delivery",
    "device-overview",
    "diagnostics",
    "dial-pad",
    "document",
    "document-doc",
    "document-jpg",
    "document-pdf",
    "document-png",
    "document-ppt",
    "document-rtf",
    "document-svg",
    "document-xls",
    "document-zip",
    "download",
    "drone",
    "e-sim",
    "edit",
    "engineer",
    "enterprise",
    "entertainment",
    "environment",
    "ethernet",
    "extender",
    "fall-detection",
    "family",
    "filter",
    "find-and-ring-your-device",
    "focus",
    "game-console",
    "gravity",
    "gyroscope",
    "heart",
    "help-circle",
    "home",
    "idea",
    "incoming-call",
    "info-circle",
    "interchangeable-batteries",
    "international",
    "iot",
    "kippy-device",
    "landline",
    "laptop",
    "loan",
    "location",
    "mail",
    "make-payment",
    "mesh-wifi-and-repeater",
    "microphone",
    "minutes-sms",
    "mobile",
    "mobiles",
    "monitor-brightness",
    "motion-sensor",
    "music-and-movies",
    "mute",
    "need-help",
    "network-tower",
    "news",
    "night-vision",
    "notification",
    "notification-muted",
    "number-1",
    "number-2",
    "number-3",
    "number-4",
    "one-number",
    "outgoing-call",
    "padlock-close",
    "padlock-open",
    "parental-control",
    "pause-circle",
    "payg",
    "payment",
    "photos",
    "pie-chart",
    "placeholder",
    "play-arrow",
    "pop-in",
    "pop-out",
    "portals-for-videos",
    "prepare",
    "price-promise",
    "price-tag",
    "public-sector",
    "public-wifi",
    "qr-code",
    "raffles",
    "return-product",
    "roaming",
    "router",
    "routines",
    "savings",
    "screen-repair",
    "search",
    "security-camera",
    "settings",
    "share-your-mins",
    "shopping-checkout",
    "shopping-trolley",
    "signed-in",
    "sim",
    "sim-swap",
    "small-and-lightweight",
    "sme",
    "sms-text",
    "soho",
    "sos",
    "sound-active",
    "student",
    "super-wifi",
    "tablet",
    "talk",
    "theft",
    "tick-outline",
    "to-do-list",
    "top-up",
    "trackisafe",
    "trainers",
    "trophy",
    "tv",
    "tv-remote",
    "unified-communication",
    "unlocked-rewards",
    "upgrade",
    "usb-modem",
    "users",
    "v-car",
    "v-car-dongle",
    "v-pet",
    "v-sim-and-device",
    "video",
    "virus-protection",
    "vodafone-store",
    "voicemail",
    "vr-headset",
    "warning",
    "watch",
    "web-protection",
    "website",
    "wifi-good",
  ],
};

for (const p in ICON_PACK_ICONS) {
  if (p.includes("-light-")) {
    ICON_PACK_ICONS[p.replace("-light-", "-dark-")] = [...ICON_PACK_ICONS[p]];
  }
}
